module.exports = __webpack_public_path__ + "static/media/UserTempLogo.3b596348.svg";